<style lang="less" scoped>  
    .left-side {
        width: 240px;
        /*background: #2b3541;*/
        // background: #404040;
		background: #191A22;
        position: fixed;
        height: 100%;
        top: 57px;
        left: 0;
        transition: all .3s;
        z-index: 20;
        box-shadow: 0 1px 8px rgba(0,0,0,0.1);
        border-right: 1px solid #fff;

        .left-side-inner {
            padding-top: 0px;
            margin-bottom: 10px;

            .left-menus {

                .menu-list {
                    float: none;
                    position: relative;
                    display: block;
                    cursor: pointer;
                    -webkit-transition: all 0.3s ease;
                    transition: all 0.3s ease;

                    .submenu-title {
                        /*color: #85919e;*/
                        color: rgba(255, 255, 255, 0.67);
                        padding-left: 24px;
                        font-size: 14px;
                        line-height: 42px;
                        height: 42px;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        i {
                            margin-right: 10px;
                        }

                        a {
                            color: rgba(255, 255, 255, 0.67);
                        }

                        a:hover {
                            color: #fff;
                        }

                        .item-icon {
                            float: right;
                            font-size: 10px;
                        }
                    }

                    /* .submenu-title:hover {
                        color: #fff;
                    } */

                    .menu-title:after {
                        font-family: "FontAwesome" !important;
                        font-style: normal;
                        vertical-align: baseline;
                        text-align: center;
                        text-transform: none;
                        text-rendering: auto;
                        position: absolute;
                        -webkit-transition: -webkit-transform .3s ease;
                        transition: transform .3s ease, -webkit-transform .3s ease;
                        content: "\f107";
                        right: 16px;
                        top: 0;
                        display: inline-block;
                        font-size: 20px;
                        -webkit-transform: scale(0.66666667) rotate(0deg);
                        -ms-transform: scale(0.66666667) rotate(0deg);
                        transform: scale(0.66666667) rotate(0deg);
                        -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
                        zoom: 1;                        
                    }

                    .sub-menu-list {
                        list-style: none;
                        display: none;
                        margin: 0;
                        padding: 0;
                        /*background: #353f4f;*/
                        // background: #333;
						background: #101116;

                        li {
                            .submenu-title {
                                /*color: #85919e;*/
                                color: rgba(255, 255, 255, 0.67);
                                font-size: 13px;
                                line-height: 40px;
                                height: 40px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                padding-left: 48px;

                                a {
                                    color: rgba(255, 255, 255, 0.67);
                                }
                            }
							
							a {
								width: 100%;
							}
                        }
                        li:hover, li.active {
                            .submenu-title {
                                color: #fff;
                                border-left: 2px solid #108ee9;

                                a {
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
                .menu-list.open {
                    .submenu-title {
                        color: #fff;
                        a {
                            color: #fff;
                        }
                    }

                    .menu-title:after {
                        content: "\f106";
                    }

                    .sub-menu-list {
                        display: block;
                    }
                }
            }
        }
		.left-side-bottom {
			height: 40px;
			line-height: 40px;
			color: #fff;
			cursor: pointer;
			text-align: center;
		}
    }

    .left-side-collapsed {
        .left-side {
            width: 0px;
            .left-side-inner {
                .left-menus{
                    .menu-list{
                        .menu-title {
                            span {
                                i {
                                    font-size: 16px;
                                }
                                span {
                                    display: none;
                                }
                                span:after {
                                    display: none;
                                }
                            }
                        }
                        .menu-title:after{
                            display: none;
                        }

                        .sub-menu-list {
                            display: none;
                        }
                    }
                    .menu-list.open {
                        
                    }
                    .menu-list.nav-hover{
                        .menu-title {
                            color: #fff;
                            span {
                                i {
                                    font-size: 16px;
                                }
                                span {
                                    position: absolute;
                                    // background: #333;
									background: #101116;
                                    padding-left: 10px;
                                    left: 1px;
                                    top: 0;
                                    min-width: 173px;
                                    text-align: left;
                                    z-index: 100;
                                    display: block;
                                }
                                span:after {
                                    right: 100%;
                                    top: 50%;
                                    border: solid transparent;
                                    content: " ";
                                    height: 0;
                                    width: 0;
                                    position: absolute;
                                    pointer-events: none;
                                    border-color: rgba(0, 0, 0, 0);
                                    border-right-color: #333;
                                    border-width: 6px;
                                    margin-top: -6px;
                                    display: block;
                                }
                            }
                        }
                        .menu-title:after{
                            display: none;
                        }

                        .sub-menu-list {
                            display: block;
                            position: absolute;
                            top: 42px;
                            left: 70px;
                            margin: 0;
                            min-width: 173px;
                            // background: #333;
							background: #101116;
                            z-index: 100;
                            -moz-border-radius: 0 0 2px 0;
                            -webkit-border-radius: 0 0 2px 0;
                            border-radius: 0 0 2px 0;
                            overflow-y: auto;
                            padding-left: 9px;
                            li {
                                .submenu-title {
                                    padding-left: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<template>
    <div class="left-side" :style="{'overflow-y': leftSideOpen ? 'visible' : 'hidden'}">

        <div class="left-side-inner">

            <!--sidebar nav start-->
            <ul class="nav nav-pills nav-stacked custom-nav left-menus">
                <li class="menu-list" v-for="(item,index) in menus" @mouseenter="itemHover($event, index)" @mouseleave="itemHover($event, index)" :class="{'open' : item.indexPath === currentActiveMenuPath,'nav-hover': hoverIndex == index}">
                    <div class="submenu-title menu-title" @click="toggleclick($event, item)">
                        <span>
                            <i :class="item.tree.icon"></i><span>{{item.label}}</span>
                        </span>
                    </div>
                    <template v-if="item.children &&  item.children.length > 0">
                        <ul class="sub-menu-list" transition="expand" >
                            <li v-for="(child,childIndex) in item.children" class="sub-menu-item" :class="{'active': child.indexPath === currentActivePath}">
                                <router-link :to="item.tree.url + '/' + child.tree.url">
                                    <div class="submenu-title"  @click="itemclick($event, item, child)"> 
                                        <span>
                                            <i :class="child.tree.icon"></i>{{child.label}}
                                        </span>
                                    </div>
                                </router-link>  
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
            <!--sidebar nav end-->
        </div>
		<div class="left-side-bottom">
			<el-tooltip class="item" effect="light" :value="true" content="点击查看版本更新内容" placement="top">
				<p @click="showTip">系统版本{{currentVersion}}({{currentUpdateTime}})</p>
			</el-tooltip>
		</div>
    </div>
</template>
<script>
	import $ from 'jquery';
    import m from 'malihu-custom-scrollbar-plugin';
    import mw from 'jquery-mousewheel';
    import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
    export default {
        props: {
            //是否保持之展开一个菜单
            uniqueOpened : {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },
        data() {
            return {
                hoverIndex: -1 // 当前hover的菜单编号
            }
        },
        computed: {
            leftSideOpen() { //左边关闭状态计算属性
                const isOpen =  this.$store.getters.framework_leftSideOpenStatus;
                return isOpen;
            },
            menus() { //显示左边菜单列表
                let menuList_ =  this.$store.getters.currentActiveMenuList;
                this.init();
                return menuList_;
            },
			currentActivePath() {
				return this.$store.getters.currentActivePath;
			},
			currentActiveMenuPath() {
				return this.$store.getters.currentActiveMenuPath;
			},
			currentVersion() {
				let exts = this.$store.getters.auth_exts;
				//初始化版本信息
				return exts.version;
			},
			currentUpdateTime() {
				let exts = this.$store.getters.auth_exts;
				//初始化版本信息
				return exts.time;
			},
        },
        mounted() {	
        },
        methods: {
            //切换关闭
            toggleclick: function(e, item) {
				let indexPath = item.indexPath;
				this.$store.dispatch('authMenuToggle',  {
					'indexPath': indexPath
				});
                //切换关闭状态
                //1.取出自己 index_, uniqueOpened_, activeIndex_
                // let activeIndex =  this.$store.getters.framework_topMenuActiveIndex;
                // this.$store.dispatch('authMenuToggle', {index: index, uniqueOpened: this.uniqueOpened, activeIndex: activeIndex});
            },
            //选项点击
            itemclick: function(e, item, item_) {
				let menuPath = item.indexPath;
				let indexPath = item_.indexPath;
                this.$store.dispatch('authMenuItemClick', {
					'indexPath': indexPath,
					'menuPath': menuPath
				});
                //激活导航
                this.$store.dispatch('frameworkLastCrumbActive' , {item: item_});
            },
            //左边关闭的时候,展示菜单信息
            itemHover: function(e, index) {
                if(!this.leftSideOpen) {
                    return;
                }
                const eType = e.type;
                this.hoverIndex = ('mouseenter' == eType ? index : '-1');
            },
            /**
        	 * 初始化
        	 */
            init() {
                var obj = this;
                this.$nextTick(function(){
                    this.bindScroll();
                    $(window).resize(function() {
                        obj.bindScroll();
                    });
                });
            },
            bindScroll() {
                let height = $(window).height();
                $('.left-side .left-side-inner>ul').mCustomScrollbar("destroy");
                $('.left-side .left-side-inner>ul').css('height', height - 56- 40 -10);   
                $('.left-side .left-side-inner>ul').mCustomScrollbar({
                     theme:"minimal-dark",
                     scrollInertia : 500
                });               
            },
			showTip() {
				this.$store.dispatch('frameworkToggleTips' , {show: true});
			}
        }
    }
</script>


// WEBPACK FOOTER //
// navmenu.vue?302f4650